import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/AppSidebar'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { HOSDashboard } from './components/HOSDashboard'
import { DVIRForm } from './components/DVIRForm'
import { HOSLogs } from './components/HOSLogs'
import { ClipboardCheck, Clock, FileText } from 'lucide-react'

export function Compliance() {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full">
        <AppSidebar />
        <main className="flex-1 overflow-auto p-6">
          <div className="max-w-7xl mx-auto space-y-6">
            <div>
              <h1 className="text-3xl font-bold tracking-tight">ELD Compliance Center</h1>
              <p className="text-muted-foreground">
                Manage Hours of Service and vehicle inspections
              </p>
            </div>

            <Tabs defaultValue="hos" className="space-y-6">
              <TabsList className="grid w-full max-w-md grid-cols-3">
                <TabsTrigger value="hos" className="gap-2">
                  <Clock className="h-4 w-4" />
                  HOS Status
                </TabsTrigger>
                <TabsTrigger value="dvir" className="gap-2">
                  <ClipboardCheck className="h-4 w-4" />
                  DVIR
                </TabsTrigger>
                <TabsTrigger value="logs" className="gap-2">
                  <FileText className="h-4 w-4" />
                  Logs
                </TabsTrigger>
              </TabsList>

              <TabsContent value="hos" className="space-y-6">
                <HOSDashboard />
              </TabsContent>

              <TabsContent value="dvir" className="space-y-6">
                <DVIRForm />
              </TabsContent>

              <TabsContent value="logs" className="space-y-6">
                <HOSLogs />
              </TabsContent>
            </Tabs>
          </div>
        </main>
      </div>
    </SidebarProvider>
  )
}
